import apiClient from './client'
import type { User, UserId, SuccessResponse } from '@/types/api'

export const usersApi = {
  // Get current user
  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>('/users/me')
    return response.data
  },

  // Get user by ID
  getUser: async (userId: UserId): Promise<User> => {
    const response = await apiClient.get<User>(`/users/${userId}`)
    return response.data
  },

  // Update user profile
  updateUser: async (
    userId: UserId,
    data: Partial<Pick<User, 'displayName' | 'realName' | 'facebookId'>>
  ): Promise<SuccessResponse> => {
    const response = await apiClient.patch<SuccessResponse>(`/users/${userId}`, data)
    return response.data
  },

  // Star a user
  starUser: async (userId: UserId): Promise<SuccessResponse> => {
    const response = await apiClient.post<SuccessResponse>(`/users/${userId}/star`)
    return response.data
  },

  // Unstar a user
  unstarUser: async (userId: UserId): Promise<SuccessResponse> => {
    const response = await apiClient.delete<SuccessResponse>(`/users/${userId}/star`)
    return response.data
  },
}
